export enum Colors {
  chlorophyll = "#1ab953",
  eggplantDark = "#30093a",
  eggplantMed = "#490b43",
  eggplantLight = "#614051",
  forest = "#228B22",
  cloud = "#dfe0e6",
  lychee = "#e1567c",
  ocean = "#1ca1f3",
  rose = "#ffc0cb",
  strawberry = "#c83f49",
}
